import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { FACTORY_V2_ADDRESSES } from '../constants';
export var GetPair = createPlugin({
    protocol: 'UNISWAP',
    type: 'GETTER',
    method: 'getPair',
    supportedContracts: FACTORY_V2_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_factory' }), // TODO: Add Uniswap V2 pools to options
            methodParams: {
                tokenA: new FctAddress({ destination: 'erc20' }),
                tokenB: new FctAddress({ destination: 'erc20' }),
            },
        },
        output: {
            address: new FctAddress({ destination: 'uniswap_pool_v2', innerIndex: 0 }),
        },
    }); },
});
